export default {
  created() {},
};
